import React, { FC } from 'react';

import Banner from './Banner';
import { BANNER_FLAG_KEYS } from './Banner.types';

const AppWideBanner: FC = () => <Banner flagKey={BANNER_FLAG_KEYS.APP} />;

export default AppWideBanner;
